import React from 'react'

import ReactionView from "./reaction-view"
import Reactions from "../../../model2/reaction/reactions"
import {Group} from "../../../data-structures/group"
import Reaction from "../../../model2/reaction/reaction"

type Props = {
    className?      : string

    size?           : number

    reactions       : Reactions
    toggleReaction? : callback
    disabled?       : boolean
}

export default function ReactionsList(props: Props) {
    return (
        <div className={Classes("ui5-reactions", props.className)}>
            {_.map(props.reactions.groupedByType, (reactionsGroup: Group, key:string) =>
                <ReactionView key           = {key}
                              size          = {props.size}
                              reactionType  = {reactionsGroup.value}
                              reactions     = {reactionsGroup.items as Reaction[]}
                              onClick       = {props.toggleReaction}
                              disabled      = {props.disabled}
                />
            )}
        </div>
    )
}
